export default __webpack_public_path__ + "static/media/coriolis-logo-light-wide.23a43102.png";